export class GetInspectionsRaw {
    public static readonly type = '[DataCollection] Get inspections raw';
}
